(function () {
function $3216735320b4c519$export$e99e2931f67913b9(selector) {
    const ELEMENT = document.querySelector(selector);
    if (!ELEMENT) throw new Error(`Element with ${selector} selector was not found!`);
    return ELEMENT;
}
function $3216735320b4c519$export$5f5ed5a772a55360(element, classes) {
    element.setAttribute("disabled", "");
    if (classes) {
        const { toAdd: toAdd, toRemove: toRemove } = classes;
        if (toAdd) element.classList.add(...toAdd);
        if (toRemove) element.classList.remove(...toRemove);
    }
}
function $3216735320b4c519$export$5ebfed0ed32f804e(element, classes) {
    element.removeAttribute("disabled");
    if (classes) {
        const { toAdd: toAdd, toRemove: toRemove } = classes;
        if (toAdd) element.classList.add(...toAdd);
        if (toRemove) element.classList.remove(...toRemove);
    }
}


async function $4199d756ab18aa20$export$cff6f7662b43f63d() {
    try {
        const RESPONSE = await fetch("https://api.adviceslip.com/advice", {
            cache: "no-cache"
        });
        if (!RESPONSE.ok) throw new Error(RESPONSE.statusText);
        return (await RESPONSE.json()).slip;
    } catch (error) {
        throw error;
    }
}


async function $a592a8b0c3ecd3a1$var$main() {
    const ADVICE = (0, $3216735320b4c519$export$e99e2931f67913b9)("#advice");
    const ADVICE_ID = (0, $3216735320b4c519$export$e99e2931f67913b9)("#advice-id");
    const GENERATE_ADVICE_BUTTON = (0, $3216735320b4c519$export$e99e2931f67913b9)("#generate-advice");
    const DICE_ICON = GENERATE_ADVICE_BUTTON.children[0];
    const ENABLE_BUTTON_CLASS = [
        "button--primary"
    ];
    const DISABLE_BUTTON_CLASS = [
        "button--disabled"
    ];
    const ICON_ANIMATION_CLASS = "motion-safe:animate-spin";
    try {
        const { advice: advice, id: id } = await (0, $4199d756ab18aa20$export$cff6f7662b43f63d)();
        ADVICE.textContent = `\u{201C}${advice}\u{201D}`;
        ADVICE_ID.textContent = id.toString();
    } catch (error) {
        console.error(error);
    } finally{
        (0, $3216735320b4c519$export$5ebfed0ed32f804e)(GENERATE_ADVICE_BUTTON, {
            toAdd: ENABLE_BUTTON_CLASS,
            toRemove: DISABLE_BUTTON_CLASS
        });
        DICE_ICON.classList.remove(ICON_ANIMATION_CLASS);
    }
    GENERATE_ADVICE_BUTTON.addEventListener("click", async function() {
        if (this.hasAttribute("disabled")) return;
        (0, $3216735320b4c519$export$5f5ed5a772a55360)(this, {
            toAdd: DISABLE_BUTTON_CLASS,
            toRemove: ENABLE_BUTTON_CLASS
        });
        DICE_ICON.classList.add(ICON_ANIMATION_CLASS);
        try {
            const { advice: advice, id: id } = await (0, $4199d756ab18aa20$export$cff6f7662b43f63d)();
            ADVICE.textContent = `\u{201C}${advice}\u{201D}`;
            ADVICE_ID.textContent = id.toString();
        } catch (error) {
            console.error(error);
        } finally{
            (0, $3216735320b4c519$export$5ebfed0ed32f804e)(this, {
                toAdd: ENABLE_BUTTON_CLASS,
                toRemove: DISABLE_BUTTON_CLASS
            });
            DICE_ICON.classList.remove(ICON_ANIMATION_CLASS);
        }
    });
}
$a592a8b0c3ecd3a1$var$main();

})();
//# sourceMappingURL=index.a19bc82f.js.map
